import type { SagaIterator } from "redux-saga";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import * as contactApi from "@/shop/api/contacts";

import * as ContactActions from "./actions";
import type { ContactAction } from "./reducer";
import { getContactsExists } from "./selectors";
import type { IContactInformation } from "../../types/contacts";

function* fetchContacts(_: ContactAction): SagaIterator {
  try {
    const contactsExists = (yield select(getContactsExists)) as boolean;

    if (contactsExists) {
      return;
    }

    yield put(ContactActions.fetchContactsStart());

    const contactData = (yield call(contactApi.fetchContactInformation)) as IContactInformation;

    yield put(ContactActions.fetchContactsSuccess({ contacts: contactData }));
  } catch {
    yield put(ContactActions.fetchContactsFail());
  }
}

export default function* contactsSaga(): SagaIterator {
  yield takeEvery(getType(ContactActions.fetchContacts), fetchContacts);
}
